module.exports = __webpack_public_path__ + "static/management-image-846c7b8b5ea267fa63e307f1fb1c6e78.png";